import axios from "axios";

const lookups = {
  namespaced: true,
  state: {
    gmbLocations: {},
    kwLocations: {},
    gaOptions: {metrics: {}, dimensions: {}, filter:{options: {}, dimensions: {}, expressions: {}}},
    competitors: {},
  },
  mutations: {
    async setGMBLocations(state, {data}){
      state.gmbLocations = data;
    },
    async setKWLocations(state, {data}){
      state.kwLocations = data;
    },
    async setGAOptions(state, {data}){
      state.gaOptions = data;
    },
    async setCompetitors(state, {data}){
      state.competitors = data;
    },
  },
  actions: {
    getAllLookups({dispatch}) {
      dispatch('getGMBLocations');
      dispatch('getKWLocations');
      dispatch('getGAOptions');
      dispatch('getCompetitors');
    },
    getGMBLocations: ({commit}) =>
      axios.get('/ajax/reports/get-locations')
        .then(({data}) => commit('setGMBLocations', {data})),
    getKWLocations: ({commit}) =>
      axios.get('/ajax/reports/get-keyword-locations')
        .then(({data}) => commit('setKWLocations', {data})),
    getGAOptions: ({commit}) =>
      axios.get('/ajax/reports/builder/get-ga-options')
        .then(({data}) => commit('setGAOptions', {data})),
    getCompetitors: ({commit}) =>
      axios.get('/ajax/reports/get-competitors')
        .then(({data}) => commit('setCompetitors', {data})),
  }
};

export default lookups;
